import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

export const navList = [
  {
    id: 1,
    path: "/",
    text: "Home",
  },
  {
    id: 2,
    path: "/about",
    text: "About",
  },
  {
    id: 3,
    path: "/services",
    text: "Services",
  },
  {
    id: 4,
    path: "/rooms",
    text: "Rooms",
  },
  {
    id: 5,
    path: "/page",
    text: "Page",
    subItems: [
      {
        id: 51,
        path: "/booking",
        text: "Booking",
      },
      {
        id: 52,
        path: "/team",
        text: "Our Team",
      },
      {
        id: 53,
        path: "/testimonial",
        text: "Testimonial",
      },
    ],
  },
  {
    id: 6,
    path: "/contact",
    text: "Contact",
  },
];

export const socialIcons = [
  {
    icon: <FaFacebookF />,
    link: "https://www.facebook.com/share/ANAeaQjW6Qcu3Rk6/",
  },
  {
    icon: <FaInstagram />,
    link: "https://www.instagram.com/hotel_gold_palaceinn/profilecard/?igsh=ZDE4MzEyeDg5ZTF4",
  },
];

export const footerItem = [
  {
    id: 1,
    header: "Company",
    UnitItem: [
      {
        name: "Home",
        path: "/home",
      },
      {
        name: "Rooms",
        path: "/rooms",
      },
      {
        name: "About Us",
        path: "/about-us",
      },
      {
        name: "Contact Us",
        path: "/contact-us",
      },
    ],
  },
  {
    id: 2,
    header: "Services",
    UnitItem: [
      {
        name: "Rooms",
      },
      {
        name: "Event & Party",
      },
      {
        name: "Banquet Hall",
      },
      {
        name: "Food & Restaurant",
      },
    ],
  },
];

export const footerContact = [
  {
    icon: <FaMapMarkerAlt />,
    name: "6th Floor, Green Palladia, Palanpore Road, Adajan Dn, Surat - 395009",
  },
  {
    icon: <FaPhoneAlt />,
    name: "+91 8866323228",
  },
  {
    icon: <FaEnvelope />,
    name: "goldpalaceinn@gmail.com.",
  },
];
